import JSEncrypt from 'jsencrypt';

import { publicKey } from './constants';

export default async function (message: string) {
    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(publicKey);

    return jsEncrypt.encrypt(message);
}
